var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "FormWrapper",
    { attrs: { title: "Education", body: "All your education here" } },
    [
      _c("UIButton", {
        staticClass: "flex justify-end mb-4",
        attrs: { icon: "plus", variant: "black", buttonText: "Add education" },
        on: { click: _vm.showModal },
      }),
      _c(
        "LoadingOverlay",
        {
          attrs: {
            hasData: !!_vm.educations,
            loading: _vm.$apollo.queries.educations.loading,
          },
        },
        _vm._l(_vm.educations, function (education) {
          return _c("ProfileEducationCard", {
            key: education.id,
            staticClass: "mt-4",
            attrs: { education: education, userId: _vm.userId },
            on: { updated: _vm.refresh, removed: _vm.refresh },
          })
        }),
        1
      ),
      _vm.isModalOpen
        ? _c("EducationModal", {
            attrs: { userId: _vm.userId },
            on: { added: _vm.refresh },
            model: {
              value: _vm.isModalOpen,
              callback: function ($$v) {
                _vm.isModalOpen = $$v
              },
              expression: "isModalOpen",
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }